import rfpsTemplate from './rfps.html';

/* @ngInject */
const RfpsConfig = ($stateProvider) => {
    $stateProvider.state('rfps', {
        url: '/rfps',
        template: rfpsTemplate,
        controller: 'RfpsController',
        controllerAs: 'rfps',
        params: {},
    });
};

export default RfpsConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/rfps/rfps.config.js
 **/